import EllipsesVerticalPath from "@ingka/ssr-icon/paths/ellipses-vertical";

export default EllipsesVerticalPath;
